import {
    GET_CHATS,
    GET_CHAT_USERS,
    CREATE_CHAT,
    DELETE_CHAT,
    GET_MESSAGES,
    SEND_MESSAGE,
    EDIT_MESSAGE,
    DELETE_MESSAGE,
    SEARCH_MESSAGES,
    UPLOAD_ATTACHMENT,
    MARK_CHAT_READ,
    MARK_MESSAGE_READ,
    MUTE_CHAT,
    CHAT_DELETED_EVENT,
    CHAT_MEMBER_REMOVED_EVENT,
    REMOVE_CHAT_MEMBER,
    ADD_CHAT_MEMBERS,
    CHAT_MEMBERS_ADDED_EVENT,
    CHAT_RECEIVE_MESSAGE,
    CHAT_UNREAD_UPDATE,
    CHAT_MESSAGE_EDITED,
    CHAT_MESSAGE_DELETED,
    CHAT_MESSAGE_READ,
    CHAT_SET_TYPING,
    CHAT_CLEAR_TYPING,
    SET_ACTIVE_CHAT,
    CLEAR_ACTIVE_CHAT,
    CLEAR_MESSAGES,
    CLEAR_CHAT_USERS,
} from './chat.types';

/** REST actions */

export const getChats = (load) => {
    return {
        type: GET_CHATS,
        payload: { load },
    };
};

export const getChatUsers = (params, load) => {
    return {
        type: GET_CHAT_USERS,
        payload: { params, load },
    };
};

export const createChat = (body) => {
    return {
        type: CREATE_CHAT,
        payload: { body },
    };
};

export const deleteChat = (chatId) => {
    return {
        type: DELETE_CHAT,
        payload: { chatId },
    };
};

export const removeChatMember = (chatId, userId) => {
    return {
        type: REMOVE_CHAT_MEMBER,
        payload: { chatId, userId },
    };
};

/** participants: [{ userId, userType }] */
export const addChatMembers = (chatId, participants) => {
    return {
        type: ADD_CHAT_MEMBERS,
        payload: { chatId, participants },
    };
};

/** Socket chat:members-added — payload: { chatId, users, participants } */
export const chatMembersAddedEvent = (data) => {
    return {
        type: CHAT_MEMBERS_ADDED_EVENT,
        payload: data,
    };
};

/** Socket chat:member-removed — payload: { chatId, userId, userType, participants } */
export const chatMemberRemovedEvent = (data) => {
    return {
        type: CHAT_MEMBER_REMOVED_EVENT,
        payload: data,
    };
};

export const getMessages = (chatId, params, load) => {
    return {
        type: GET_MESSAGES,
        payload: { chatId, params, load },
    };
};

export const sendMessage = (chatId, body) => {
    return {
        type: SEND_MESSAGE,
        payload: { chatId, body },
    };
};

export const editMessage = (messageId, body) => {
    return {
        type: EDIT_MESSAGE,
        payload: { messageId, body },
    };
};

export const deleteMessage = (messageId) => {
    return {
        type: DELETE_MESSAGE,
        payload: { messageId },
    };
};

export const searchMessages = (chatId, params) => {
    return {
        type: SEARCH_MESSAGES,
        payload: { chatId, params },
    };
};

export const uploadAttachment = (chatId, files) => {
    return {
        type: UPLOAD_ATTACHMENT,
        payload: { chatId, files },
    };
};

export const markChatRead = (chatId) => {
    return {
        type: MARK_CHAT_READ,
        payload: { chatId },
    };
};

export const markMessageRead = (messageId) => {
    return {
        type: MARK_MESSAGE_READ,
        payload: { messageId },
    };
};

export const muteChat = (chatId, muted) => {
    return {
        type: MUTE_CHAT,
        payload: { chatId, muted },
    };
};

/** Socket actions */

export const chatDeletedEvent = (data) => {
    return {
        type: CHAT_DELETED_EVENT,
        payload: data,
    };
};

export const chatReceiveMessage = (data) => {
    return {
        type: CHAT_RECEIVE_MESSAGE,
        payload: data,
    };
};

export const chatUnreadUpdate = (data) => {
    return {
        type: CHAT_UNREAD_UPDATE,
        payload: data,
    };
};

export const chatMessageEdited = (data) => {
    return {
        type: CHAT_MESSAGE_EDITED,
        payload: data,
    };
};

export const chatMessageDeleted = (data) => {
    return {
        type: CHAT_MESSAGE_DELETED,
        payload: data,
    };
};

export const chatMessageRead = (data) => {
    return {
        type: CHAT_MESSAGE_READ,
        payload: data,
    };
};

export const chatSetTyping = (data) => {
    return {
        type: CHAT_SET_TYPING,
        payload: data,
    };
};

export const chatClearTyping = (data) => {
    return {
        type: CHAT_CLEAR_TYPING,
        payload: data,
    };
};

/** UI state actions */

export const setActiveChat = (chat) => {
    return {
        type: SET_ACTIVE_CHAT,
        payload: chat,
    };
};

export const clearActiveChat = () => {
    return {
        type: CLEAR_ACTIVE_CHAT,
    };
};

export const clearMessages = () => {
    return {
        type: CLEAR_MESSAGES,
    };
};

export const clearChatUsers = () => {
    return {
        type: CLEAR_CHAT_USERS,
    };
};
